import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=a00b2b56&scoped=true"
import script from "./BatchOrder.vue?vue&type=script&lang=js"
export * from "./BatchOrder.vue?vue&type=script&lang=js"
import style0 from "./BatchOrder.vue?vue&type=style&index=0&id=a00b2b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00b2b56",
  null
  
)

export default component.exports